module.exports = __webpack_public_path__ + "img/volume-low.ddf27e16.svg";